export { I18NHeading } from "./I18NHeading";
export type { I18NHeadingProps } from "./I18NHeading.interface";